import QRCode from 'qrcode'
import { formatRupiah, getPublicCatalogHref } from '../catalogUrl'
import { PROMO_TYPES } from './constants'
import type { BannerRenderData } from './types'
import { normalizePlanId } from '../plans'

export function getPromoLabel(promoType: string) {
  return PROMO_TYPES.find((p) => p.id === promoType)?.label || promoType
}

export function buildBannerData(input: {
  brand: {
    name: string
    slug: string
    logoUrl?: string | null
    colorTheme?: string | null
    whatsapp?: string | null
    subdomain?: string | null
  }
  product: {
    name: string
    price: string | number
    discountPrice?: string | number | null
    images?: string[] | null
  }
  promoType: string
  plan?: string | null
  catalogUrl?: string
  qrDataUrl?: string
}): BannerRenderData {
  const plan = normalizePlanId(input.plan)
  const catalogUrl =
    input.catalogUrl ||
    (typeof window !== 'undefined'
      ? `${window.location.origin}${getPublicCatalogHref({ slug: input.brand.slug, subdomain: input.brand.subdomain, plan })}`
      : getPublicCatalogHref({ slug: input.brand.slug, subdomain: input.brand.subdomain, plan }))

  return {
    brandName: input.brand.name,
    brandLogo: input.brand.logoUrl,
    brandColor: input.brand.colorTheme || '#3b82f6',
    productName: input.product.name,
    productImage: input.product.images?.[0] ?? null,
    price: formatRupiah(input.product.price),
    discountPrice: input.product.discountPrice ? formatRupiah(input.product.discountPrice) : null,
    promoLabel: getPromoLabel(input.promoType),
    catalogUrl: catalogUrl.startsWith('http') ? catalogUrl : `${window.location.origin}${catalogUrl}`,
    qrDataUrl: input.qrDataUrl,
    whatsapp: input.brand.whatsapp,
  }
}

export async function generateQrDataUrl(url: string) {
  return QRCode.toDataURL(url, {
    width: 200,
    margin: 2,
    color: { dark: '#0f2b60', light: '#ffffff' },
  })
}

export const CAMPAIGN_BANNER_SIZES = [
  'instagram_feed',
  'instagram_story',
  'facebook',
  'whatsapp_story',
] as const
